import React, { useState } from 'react';
import { Col, Container, Form, Image, Modal, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { RiArrowRightSLine } from 'react-icons/ri';
import './Blc_BlogSearch.css';
import { BsSearch } from "react-icons/bs";
import { Link } from 'react-router-dom';
import { BsXLg } from "react-icons/bs";



const Blc_BlogSearch = ({ show, handleClose, items }) => {

    const blogSearchBox = document.getElementById('blogSearchBox');
    const [searchResult, setSearchResult] = useState(items);
    const [searchText, setSearchText] = useState('');

    function formatQuery(str) {
        return str.split(' ').join('-');
    }

    const handleOnChange = e => {
        const text = e.target.value;
        if (text.length === 0) {
            setSearchText('');
            setSearchResult(items);
        }
        else {
            setSearchText(text);
            const filtered = items?.filter(e => e.blc_news.toLowerCase().indexOf(text?.toLowerCase()) > -1 || e.blc_news_name.toLowerCase().indexOf(text?.toLowerCase()) > -1);
            setSearchResult(filtered);
        }

    }

    blogSearchBox?.addEventListener("keypress", function (event) {
        if (event.key === "Enter") {
            event.preventDefault();
        }
    });

    return (
        <Modal show={show} fullscreen onHide={handleClose}>
            {/* <Modal.Header closeButton>
                <Modal.Title>Search Results</Modal.Title>
            </Modal.Header> */}
            <Modal.Body>
                <Container>
                    <div className='blogSearch-title'>
                        <h2>Search Results</h2>
                        <BsXLg
                            onClick={handleClose}
                            size={22}
                            style={{ color: '#ec008c', cursor: 'pointer' }} />
                    </div>
                    <Form className="d-flex blogSearchForm">
                        <Form.Control
                            id='blogSearchBox'
                            onChange={handleOnChange}
                            type="search"
                            placeholder="Search"
                            className="me-2"
                            aria-label="Search"
                        />
                        <Button disabled className="searchBoxSearchBtn">
                            <BsSearch />
                        </Button>
                    </Form>
                </Container>

                <Container>
                    <Row className="g-5 my-4">

                        {
                            searchResult.length > 0 ? searchResult.map(data => <Col xs={12} sm={12} md={4} lg={4} style={{ position: 'relative' }}>
                                <Image src={data.blc_news_img.data[0].attributes.url} className='old-news-thumbnail' rounded />

                                <h4 className='old-news-title'> {data.blc_news_name} </h4>
                                <p className="old-news-caption  my-3">
                                    {data.blc_news}
                                </p>
                                <p className='old-news-date'>{data.blc_news_date}</p>


                                <Link to={`/blchighlights?newsHeading=${formatQuery(data.blc_news_name)}&newsId=${data.id}`} >
                                    <button className="readMore-btn">
                                        Read more <RiArrowRightSLine />
                                    </button>
                                </Link>
                            </Col>)
                                : <h6 className='text-danger text-center my-5'>No results found!</h6>
                        }

                    </Row>
                </Container>

            </Modal.Body>
        </Modal >
    );
};

export default Blc_BlogSearch;